<template>
<v-avatar v-if="this.user.photoURL === null" :style="{backgroundColor: color}" :data-initial="initials" class="avatar black--text" :size="avatarSize">
  {{initials}}
  <!--  avatar -->
</v-avatar>

<v-avatar v-else class="avatar" :size="avatarSize">
  <img :src="this.user.photoURL">
</v-avatar>
</template>

<script>
export default {
  name: "avatar",
  props: {
    user: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: "#f2f2f2"
    },
    avatarSize: {
      type: String,
      default: "30px"
    }
  },
  data: function() {
    return {
      initials: ""
    };
  },
  created: function() {
    // Split the username into initials if there is not a photo
    this.initials = this.user.displayName
      .split(" ")
      .map(word => {
        return word[0];
      })
      .join("");
  }
};
</script>

<style lang="scss" scoped>
figure.avatar {
    color: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Avatar.vue